export default __webpack_public_path__ + "static/media/ReviewerPersona.79181a03.png";